import type { SsoUser } from '@domain/entities';
import type { IUserRepository } from '@domain/repositories';

export class ToggleUserStatusUseCase {
  constructor(private readonly userRepository: IUserRepository) {}

  async execute(user: SsoUser): Promise<SsoUser> {
    return user.status === 'SUSPENDED'
      ? this.userRepository.reactivate(user.id)
      : this.userRepository.suspend(user.id);
  }
}
